import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  ISensorIdMapping,
  ISensorIdMappingRow,
} from '../../../../view/settings/api-automation-settings/sensor-id-mapping/sensor-id-mapping.model';

export enum ActionTypes {
  SENSOR_ID_MAPPINGS_DATA_LOADING = '[SENSOR_ID_MAPPINGS] SENSOR_ID_MAPPINGS DATA LOADING',
  SENSOR_ID_MAPPINGS_DATA_LOADED = '[SENSOR_ID_MAPPINGS] SENSOR_ID_MAPPINGS DATA LOADED',
  GET_SENSOR_ID_MAPPING = '[SENSOR_ID_MAPPINGS] GET_SENSOR_ID_MAPPING LOADING',
  GET_SENSOR_ID_MAPPING_COMPLETED = '[SENSOR_ID_MAPPINGS] GET_SENSOR_ID_MAPPING COMPLETED',
  ADD_SENSOR_ID_MAPPING = '[SENSOR_ID_MAPPINGS] ADD_SENSOR_ID_MAPPING',
  ADD_SENSOR_ID_MAPPING_COMPLETED = '[SENSOR_ID_MAPPINGS] ADD_SENSOR_ID_MAPPING COMPLETED',
  EDIT_SENSOR_ID_MAPPING = '[SENSOR_ID_MAPPINGS] EDIT_SENSOR_ID_MAPPING',
  EDIT_SENSOR_ID_MAPPING_COMPLETED = '[SENSOR_ID_MAPPINGS] EDIT_SENSOR_ID_MAPPING COMPLETED',
  DELETE_SENSOR_ID_MAPPINGS = '[SENSOR_ID_MAPPINGS] DELETE_SENSOR_ID_MAPPINGS',
  DELETE_SENSOR_ID_MAPPINGS_COMPLETED = '[SENSOR_ID_MAPPINGS] DELETE_SENSOR_ID_MAPPINGS COMPLETED',
  CHANGE_ACTIVITIES_DATA_LOADING = '[SENSOR_ID_MAPPINGS] CHANGE_ACTIVITIES DATA LOADING',
  CHANGE_ACTIVITIES_DATA_COMPLETED = '[SENSOR_ID_MAPPINGS] CHANGE_ACTIVITIES DATA COMPLETED',
  FETCH_ERROR = '[SENSOR_ID_MAPPINGS] FETCH ERROR',
}

export class SensorIdMappingsLoading implements Action {
  readonly type = ActionTypes.SENSOR_ID_MAPPINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class SensorIdMappingsLoaded implements Action {
  readonly type = ActionTypes.SENSOR_ID_MAPPINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<ISensorIdMapping>) {}
}

export class GetSensorIdMapping implements Action {
  readonly type = ActionTypes.GET_SENSOR_ID_MAPPING;

  constructor(public recordId: number) {}
}

export class GetSensorIdMappingCompleted implements Action {
  readonly type = ActionTypes.GET_SENSOR_ID_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ISensorIdMapping>) {}
}
export class AddSensorIdMapping implements Action {
  readonly type = ActionTypes.ADD_SENSOR_ID_MAPPING;

  constructor(
    public record: ISensorIdMappingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddSensorIdMappingCompleted implements Action {
  readonly type = ActionTypes.ADD_SENSOR_ID_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ISensorIdMapping>) {}
}
export class EditSensorIdMapping implements Action {
  readonly type = ActionTypes.EDIT_SENSOR_ID_MAPPING;

  constructor(
    public recordId: number,
    public record: ISensorIdMappingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditSensorIdMappingCompleted implements Action {
  readonly type = ActionTypes.EDIT_SENSOR_ID_MAPPING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ISensorIdMapping>) {}
}
export class DeleteSensorIdMappings implements Action {
  readonly type = ActionTypes.DELETE_SENSOR_ID_MAPPINGS;

  constructor(public payload: number[]) {}
}

export class DeleteSensorIdMappingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_SENSOR_ID_MAPPINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ChangeActivitiesDataLoading implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_LOADING;
}

export class ChangeActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type SensorIdMappingActions =
  | SensorIdMappingsLoading
  | SensorIdMappingsLoaded
  | GetSensorIdMapping
  | GetSensorIdMappingCompleted
  | AddSensorIdMapping
  | AddSensorIdMappingCompleted
  | EditSensorIdMapping
  | EditSensorIdMappingCompleted
  | DeleteSensorIdMappings
  | DeleteSensorIdMappingsCompleted
  | ChangeActivitiesDataLoading
  | ChangeActivitiesDataCompleted
  | FetchError;
